import { Outlet } from "react-router-dom";
import styled from "styled-components";
import SidebarComponent from "../../components/Sidebar";
import { createContext, useState } from "react";
import { useAppSelector } from "../../store";

import HeaderComponent from "../../components/Header";

interface IHeaderContext {
  headerTitle?: string;
  isRightSideOpen?: boolean;
  backAction?: () => void;
  setBackAction?: React.Dispatch<
    React.SetStateAction<(() => void) | undefined>
  >;
  setHeaderTitle?: React.Dispatch<React.SetStateAction<string | undefined>>;
  setIsRightSideOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const HeaderContext = createContext<IHeaderContext>({
  headerTitle: undefined,
  isRightSideOpen: false,
  backAction: undefined,
  setBackAction: undefined,
  setIsRightSideOpen: undefined,
  setHeaderTitle: undefined,
});

const MainLayout = () => {
  const authState = useAppSelector((state) => state.authReducer);

  const [backAction, setBackAction] = useState<() => void>();
  const [headerTitle, setHeaderTitle] = useState<string>();
  const [isRightSideOpen, setIsRightSideOpen] = useState<boolean>(false);

  return (
    <HeaderContext.Provider
      value={{
        isRightSideOpen,
        headerTitle,
        backAction,
        setBackAction,
        setIsRightSideOpen,
        setHeaderTitle,
      }}
    >
      <Container>
          {authState.me && <SidebarComponent />}
          {authState.me && (
            <HeaderWrapper>
              <HeaderComponent />
            </HeaderWrapper>
          )}
          <WrapperOutlet>
            <Outlet
              context={{ setBackAction, setIsRightSideOpen, setHeaderTitle }}
            />
          </WrapperOutlet>
      </Container>
    </HeaderContext.Provider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100svh;
  background-color: #1a1a1a;
  box-sizing: border-box;
`;

const HeaderWrapper = styled.div`
  display: none;
  position: relative;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 60px;
    background-color: #222;
    z-index: 1000;
    display: flex;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
`;

const WrapperOutlet = styled.div`
  box-sizing: border-box;
  flex: 1;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    margin-top: 60px;
  }
`;

export default MainLayout;
